// GA4 event helper — no-ops until the visitor has accepted cookies and gtag is loaded
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch { /* analytics must never break the app */ }
};
